import { COLORS, hexToRGB } from '../config/colors/colors';

export const baseShadowStyle = () => `
    box-shadow:
        0 0 1px ${hexToRGB(COLORS.black, 0.04)},
        0 2px 6px ${hexToRGB(COLORS.black, 0.04)},
        0 10px 20px ${hexToRGB(COLORS.black, 0.04)};
`;
